export default {
  推荐66人: `Refer 66 Friends, Win your trip to FC Barcelona`,
  成为EBC推荐官: "Become an EBC Referral and enjoy a glorious VIP journey",
  立即参与: "Register Now",
  活动规则与要求: "Event Rules and Requirements",
  每一次推荐: "Every referral is a golden assist on your way to FC Barcelona.",
  参与规则: "How to Participate:",
  成为EBC推荐官并邀请66人: "Become an EBC Referral and invite 66 friends;",
  所有被邀请人均入金大于等于$500: `Each invite must deposit at least $500 and complete a trade.`,
  参与方法: "How to Join:",
  立即推荐:
    "Start referring now and celebrate legendary moments with your friends.",
  登录EBC用户中心: "Log in to EBC User Centre",
  "进入“大赛推荐官”活动页面": `Go to the "Contest Referral" event page`,
  生成您的邀请链接或二维码: "Generate your unique invitation link or QR code",
  巴萨荣耀之旅: "The Champion's Road to FC Barcelona",
  每笔订单都是攻守博弈的艺术: `Every trade is a delicate balance of attack and defence. Every decision you make can be a game-changing goal in the markets. Pride, glory, and an unforgettable FC Barcelona experience await the victors of EBC's Million Dollar Trading Challenge.`,
  活动时间: "Event Duration:",
  "2025年2月22日":
    "February 22, 2025 01:00:00 (MT4/MT5 time) - August 2025 (MT4/MT5 time)",
  活动规则: "Event Rules",
  ruleList: [
    "This event does not conflict with normal referral rewards and other activities.",
    "The invitee needs to complete the deposit and transaction. Third-party transfers are invalid.",
    "Referral rewards apply only to compliant traders. EBC reserves the right to revoke bonuses for any violations.",
    "Accounts registered through referral are not allowed to transfer agents.",
    "The award is subject to valid account activation, VIP viewing seats include air tickets and accommodation.",
    "EBC Financial Group reserves the right to make the final decision of this event.",
  ],
};
